/** Flat-list sibling connector helpers for task hierarchy UI. */
import { computeDisplayLevel } from '@/features/tasks/utils/ui/taskListItemUtils';

/**
 * Level of a task in the current flat list (same inputs as connector styling).
 * @param {import('@/types').Task | undefined} task
 * @param {string} indentationType
 * @param {boolean} isExecutionView
 */
export const listDisplayLevel = (task, indentationType, isExecutionView) =>
  task ? computeDisplayLevel(task, indentationType, isExecutionView, []) : -1;

/** Uncompleted rows extend the vertical connector; completed siblings are skipped. */
export const isUncompletedConnectorTask = (task) =>
  Boolean(task && !task.completed);

/**
 * Whether this row is the last sibling at its display level (ignoring deeper descendants
 * that appear later in a depth-first flat list).
 */
export const isLastSiblingInFlatList = (
  tasks,
  index,
  displayLevel,
  indentationType,
  isExecutionView,
) => {
  for (let i = index + 1; i < tasks.length; i++) {
    const nextTask = tasks[i];
    const nextLevel = listDisplayLevel(
      nextTask,
      indentationType,
      isExecutionView,
    );
    if (nextLevel > displayLevel) continue;
    if (nextLevel < displayLevel) return true;
    if (isUncompletedConnectorTask(nextTask)) return false;
  }
  return true;
};

/**
 * Whether this row is the first sibling at its display level.
 */
export const isFirstSiblingInFlatList = (
  tasks,
  index,
  displayLevel,
  indentationType,
  isExecutionView,
) => {
  for (let i = index - 1; i >= 0; i--) {
    const prevTask = tasks[i];
    const prevLevel = listDisplayLevel(
      prevTask,
      indentationType,
      isExecutionView,
    );
    if (prevLevel > displayLevel) continue;
    if (prevLevel < displayLevel) return true;
    if (isUncompletedConnectorTask(prevTask)) return false;
  }
  return displayLevel > 0;
};
